import { googleRequests } from "api/googleApi";
import React from "react";
import { ReferenceField, TextField } from "react-admin";

const GoogleRoomField = ({ label = "Google зала", source = "googleCourseRefId" }) => {
  return (
    <ReferenceField
      source={source}
      label={label}
      reference={googleRequests.getGoogleRoomsSelect()}
      emptyText="-"
    >
      <TextField source="name" />
    </ReferenceField>
  );
};

export default GoogleRoomField;
